<template>
	<div >
		<div class="module_title05">
			<span>近四个周里程分析：</span>
		</div>
		<div class="ibox-content alarm_info_list" style="height:400px;">
			<div ref="line" :style="lineStyle"></div>
		</div>
	</div>
</template>
<script>
//vuex
import {mapState} from 'vuex'
import {INFO_EMPTY,OPERATE_EXCEPTION} from 'static/message'
let echarts = require('echarts/dist/echarts.simple.min');
var chart = null
export default {
  	name: 'LineRComp',
  	data () {
    	return {
    		weekInfo:[],
    		param:{
    			length:4,
    			stasType:0,
    			timeType:2,
    			vehicleId:13
    		}
    	}
  	},
  	props:['vehicleId'],
  	computed: {
		lineStyle: function() {
			return {
				width: '100%',
				height: '100%'
			}

		},
		...mapState({
		  	currentIndex:state => state.home.currentIndex,
		  	curSubTab:state=>state.home.curSubTab
		})
	},
	watch:{
	  	currentIndex(val){
	  		if(val.indexOf('file') != -1){
	  			chart.resize()
	  			this.setChart()
	  		}
	  	},
	  	curSubTab(val){
		  	if(val=='detailHome'){
		  		chart.resize()
		  		this.setChart()
		  	}
		}
	},
   	beforeMount(){
   		this.param.vehicleId = this.vehicleId;
		this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/reports/',{params:this.param})
		  	.then((response)=>{
		  		if(response.body.success){
		  			if(response.body.data){
		  				this.$set(this,'weekInfo',response.body.data);
		  				this.setChart()
		  			}else{
		  				this.$emit('adjustTip',INFO_EMPTY.replace('{1}','4个周里程'))	
		  			}
		  		}else{
		  			this.$emit('adjustTip',response.body.message)	
		  		}
		  	},(response)=>{
		  		this.$emit('adjustTip',response.body.message)
		  	})
		  	.catch((response)=>{
		  		this.$emit('adjustTip',OPERATE_EXCEPTION)	
		  	})
		  },
		methods:{
			setChart(){
				chart = echarts.init(this.$refs.line);
			  	let lineData = [];
			  	let lineTitle = [];
			  	this.weekInfo.forEach(function(item, i) {
			  		lineData.push(item.mileage);
			  		lineTitle.push(item.yearWeek)
			  	})
				chart.setOption({
				  		title:{
				  			text:'近四个周里程分析',
				  			textBaseline:'middle'
				  		},
				  		grid:{
				  			left:'8%',
				  			right:'2%',
				  			top:'10%',
				  			bottom:'10%'
				  		},
				  		xAxis:[
				  			{
				  				type:'category',
				  			//	boundaryGap:false,
				  				data:lineTitle,
				  				axisTick:{
				  					show:false//不显示坐标轴刻度
								},
								axisLine:{
									lineStyle:{
										color:'#bbb'
									}
								}   
				  			}
				  		],
				  		yAxis:[
				  			{
				  				type:'value',
				  				minInterval: 1,
				  				min:0,
				  				axisLine:{
									lineStyle:{
										color:'#bbb'
									},
				  					show:false//不显示坐标轴
				  				}
				  			}
				  		],
				  		series:[
				  			{
				  				name:'',
				  				type:'line',
				  				symbol:'emptycircle',
								symbolSize:10,
				  				label:{
				  					normal:{
				  						show:true,
				  						position:'top',
				  						textStyle:{
				  							color:'#000'
				  						},
				  						formatter: '{c}km'
				  					}
								},
								itemStyle:{
									normal:{
										color:"#1AB394",
										borderWidth:2
									}
								}, 
				  				smooth:true,//显示平滑曲线
				  				lineStyle:{
				  					normal:{
				  						color:'#1AB394',
				  						width:3
				  					}
				  				},
				  			//	data:[0,0,0,2000,2800,3500,2300,0,0,0,0,0]
				  				data:lineData
				  			}
				  		]
				  });	
		  		$(window).resize(chart.resize);
			}
		}

}
</script>


// WEBPACK FOOTER //
// LineRComp.vue?27501d4f